export default __webpack_public_path__ + "static/media/arrow_down_enabled.c3bea1a0.svg";